import React from 'react'

export default function index() {
    return (
        <div className="w-full bg-gray-900 rounded-2xl p-5">
            <div className="flex">
                <div className="flex items-center w-10"></div>
                <div className="flex text-sm text-gray-500 font-bold py-5 flex-1">
                    <div className="w-1/2 text-center">Ранг</div>
                    <div className="w-full text-center">Имя игрока</div>
                    <div className="w-full text-center">Средний рейтинг</div>
                    <div className="w-full text-center">Коэф у/c</div>
                    <div className="w-1/3 text-center">K/D/A</div>
                    <div className="w-full text-center">Коэф. выигрышей</div>
                    <div className="w-full text-center">Процент хэдшотов</div>
                </div>
            </div>
            <div className="whitespace-nowrap font-bold space-y-2 h-80 overflow-y-auto scrollbar pr-2 text-white">
                <div className="flex">
                    <div className="flex items-center w-10">1</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">2</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/10.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">3</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/6.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">4</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">5</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">6</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">7</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">8</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">9</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex items-center w-10">10</div>
                    <div className="flex items-center justify-center flex-1 bg-mainBlack rounded-xl py-4">
                        <div className="w-1/2 text-center">
                            <img className="w-10 m-auto" src="/static/images/levels/1.png" alt="" />
                        </div>
                        <div className="w-full text-center">James</div>
                        <div className="w-full text-center">1.51</div>
                        <div className="w-full text-center">4.31</div>
                        <div className="w-1/3 text-center">20 / 4 / 2</div>
                        <div className="w-full text-center">2.0</div>
                        <div className="w-full text-center">90.12%</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
